/* global tap */
import { get } from "psl";

const ReactTapfiliate = {
  initialize: (accountId) =>
    new Promise((resolve) => {
      ((d, s, v, c, e, y) => {
        ((e = d.createElement(s)), (y = d.getElementsByTagName(s)[0]));
        e.async = 1;
        e.src = v;
        if (c) {
          e.addEventListener(
            "load",
            (e) => {
              c(null, e);
            },
            false,
          );
        }
        y.parentNode.insertBefore(e, y);
      })(
        document,
        "script",
        "https://script.tapfiliate.com/tapfiliate.js",
        () => {
          tap("create", accountId, { integration: "javascript" });
          tap("detect", { cookie_domain: get(window.location.hostname) || "" });
          resolve();
        },
      );
    }),
  sendEvent: (accountId, event, options) => {
    if (!window.tap) {
      console.warn("Tapfiliate initialize must be called first");
      return null;
    }
    tap("create", accountId, { integration: "javascript" });
    if (event == "conversion" && options) {
      const { currency, amount, customer_id, coupons } = options;
      tap(event, null, amount, {
        currency,
        customer_id,
        coupons,
      });
    } else {
      tap(event);
    }
  },
};

export default ReactTapfiliate;
